import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/gluecksspirale/spielen',
      game: 'Gluecksspirale',
      description:
        'GlücksSpirale online spielen am Samstag ✓: Ein Los ist Ihre Chance auf 10.000 € monatlich für 20 Jahre oder einen Sofortbetrag von 2,1 Mio. €!',
      seoDescription:
        'Ein GlücksSpirale-Los ist Ihre Chance auf 1,2 Mio. € sofort und 5.000 € monatlich, 20 Jahre lang! Losnummer, Zusatzlotterien, Laufzeit wählen und GlücksSpirale am Samstag online bei Ihrer Landeslotteriegesellschaft spielen.',
      title: 'GlücksSpirale spielen ► Samstag',
      gameGluecksspirale: 'standard',
      seoHeadline: 'GlücksSpirale | LOTTO.de - Spielen beim Original!',
    },
  };
}
